import { TrashIcon } from '@/components/icons/TrashIcon'
import { AudienceIcon } from '@/components/mediaBuying/adCampaign/AudienceIcon'

const SelectionList = ({ audiences, color, onRemove }) => {
    return (
        <div className="tw:flex tw:flex-col tw:border-t tw:border-b tw:divide-y">
            {audiences.map((audience) => (
                <div
                    className="tw:border-l-4 tw:hover:bg-gray-500 tw:flex tw:justify-between tw:group"
                    style={{ borderLeftColor: color }}
                    key={audience.id}
                >
                    <div className="tw:py-4 tw:px-5 tw:flex tw:gap-1.5 tw:items-center tw:justify-center">
                        {audience.icon && <AudienceIcon icon={audience.icon} />}

                        <span className="tw:text-sm">{audience.name}</span>
                    </div>
                    <div className="tw:bg-gradient-to-r tw:from-transparent tw:to-primary-background tw:group-hover:block tw:hidden">
                        <button
                            className="tw:pl-12 tw:pr-5 tw:py-4"
                            onClick={() => onRemove && onRemove(audience.id)}
                            type="button"
                        >
                            <TrashIcon className="tw:size-5 tw:cursor-pointer tw:text-blue-300" />
                        </button>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default SelectionList
